import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, of, switchMap } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { getDisableOnboarding, isTimeDoctor } from 'src/app/app/app.constants';
import { hasMandatoryCall } from 'src/app/common/menu-def.provider';
import { NewBillingState } from 'src/app/pages/new-billing/store/state';
import { BrandingService } from 'src/app/services/branding.service';
import { AuthSelectors } from 'src/app/store/auth/auth.selectors';
import { AuthState } from 'src/app/store/auth/auth.state';
import { CompanySubscription } from 'src/models';
import { GrowthBookService } from '../growthbook/service';
const allowedStatuses: Array<CompanySubscription['status']> = ['paid', 'trial'];

@Injectable({
  providedIn: 'root',
})

export class TrialWidgetService {
  constructor(
    private readonly store: Store,
    private readonly branding: BrandingService,
    private readonly growthBook: GrowthBookService,
  ) { }

  canShowTrialWidget() {
    const billingDetails$ = this.store.select(NewBillingState.updatedBillingDetails);

    return this.store.select(AuthSelectors.company).pipe(
      switchMap((company) => {
        return !company?.id ? of(false) : billingDetails$.pipe(
          filter((billingDetails) => !!billingDetails?.customerStatus),
          map(({ customerStatus }) => {
            const { userSettings, role, id } = company;
            const isCompanyInTrial = customerStatus === 'trial';
            const hasBillingAccess = !this.branding.billingDisabled() && (role === 'owner' || userSettings?.billingAccess);

            return !isTimeDoctor(id) && isCompanyInTrial && hasBillingAccess;
          }),
        );
      }),
    );
  }

  canSeeOnboardingWidget(): Observable<boolean> {
    const company = this.store.selectSnapshot(AuthState.company);

    const { userSettings, id: companyId, subscription } = company;
    const custom = userSettings?.custom;

    const hideSidebar = getDisableOnboarding();
    const trackedAllCompleted = custom?.completedStep?.['trackedAll'];
    const allowedSubscriptionStatus = allowedStatuses.includes(subscription.status);

    return of(
      !hideSidebar &&
      !isTimeDoctor(companyId) &&
      allowedSubscriptionStatus &&
      !custom?.welcomeSidebarCompleted &&
      !trackedAllCompleted &&
      !hasMandatoryCall(company),
    );
  }

}
